  import React, { useEffect, useRef, useState } from "react";
  import { cityList, stateListData, validateAddress } from "@/api/bid";

  const DynamicForm = ({
    fieldsConfig,
    setCifFormDetails,
    cifFormetails,
    preFilledEmail,
    setHaveErrors,
    statePrefilled,
    registerValidationTrigger,
    validateAgentEmail,
    col,
    externalErrors = {},
    setExternalFormErrors,
    validateCobuyerEmail
  }) => {
    const [errors, setErrors] = useState({});
    const [state, setState] = useState([]);
    const [citySuggestions, setCitySuggestions] = useState([]);
    const [allCities, setAllCities] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [zipTouched, setZipTouched] = useState(false);
    const [invalidCombination, setInvalidCombination] = useState(false);
const fieldRefs = useRef({});

    const fetchStateValues = async () => {
      try {
        const data = await stateListData();
        setState(data?.data || []);
      } catch (error) {
        console.log(error);
      }
    };

    const fetchCities = async () => {
      if (cifFormetails?.stateId) {
        try {
          const response = await cityList(cifFormetails?.stateId);
          setAllCities(response?.data?.data || []);
          if (!cifFormetails.city) {
            setCifFormDetails((prevDetails) => ({
              ...prevDetails,
              city: "",
            }));
          }
          setCitySuggestions([]);
          setShowSuggestions(false);
        } catch (error) {
          console.error("Error fetching cities:", error);
          setAllCities([]);
        }
      }
    };

    const checkStateCityZip = async () => {
      try {
        const payload = {
          address1: cifFormetails.address1,
          city: cifFormetails.city,
          state: cifFormetails.stateId,
          zip: cifFormetails.zip,
        };
        const data = await validateAddress(payload);
        if (data?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
          setInvalidCombination(true);
          setErrors((prevErrors) => ({
            ...prevErrors,
            zip: "Provided zip code is not valid for selected state",
          }));
          setHaveErrors(true);
        } else {
          setInvalidCombination(false);
          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors.zip;
            return newErrors;
          });
          const otherErrors =
            Object.values(errors).filter((error) => error).length > 0;
          setHaveErrors(otherErrors);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const handleInputChange = (name, event,context) => {
      const { value } = event.target;
      const field = fieldsConfig.find((f) => f.name === name);
      const error = validateField(name, value, field?.required,context);
      setCifFormDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));

      if (name === "city" && value.length > 2) {
        const filteredCities = allCities.filter((city) =>
          city.toLowerCase().includes(value.toLowerCase())
        );
        setCitySuggestions(filteredCities);
        setShowSuggestions(true);
      } else if (name === "city") {
        setCitySuggestions([]);
        setShowSuggestions(false);
      }

      checkFormValidity();
    };

    const handleBlur = async (name, event,context) => {
      const { value } = event.target;
      const field = fieldsConfig.find((f) => f.name === name);
      const error = validateField(name, value, field?.required,context);

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));
      if (name === "zip" && value && cifFormetails.stateId) {
        setZipTouched(true);
        // await checkStateCityZip();
      }
 if (externalErrors?.[field.name]) {
    setExternalFormErrors((prev) => {
      const updated = { ...prev };
      delete updated[field.name];
      return updated;
    });
  }
      checkFormValidity();
    };

    const checkFormValidity = () => {
      const requiredFieldsFilled = fieldsConfig
        .filter((field) => field.required)
        .every((field) => {
          return cifFormetails[field.name]?.trim();
        });
      const hasNoErrors = Object.values(errors).every((error) => !error);
      setHaveErrors(!(requiredFieldsFilled && hasNoErrors));
    };

    const handleSuggestionClick = (suggestion) => {
      setCifFormDetails((prevDetails) => ({
        ...prevDetails,
        city: suggestion,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        city: validateField("city", suggestion, true),
      }));
      setCitySuggestions([]);
      setShowSuggestions(false);
    };
    const fieldGroupLabels = {
      firstName: "Name",
      lastName: "Name",
      address1: "Address",
      address2: "Address",
      zip: "Zipcode",
      city: "City",
      email: "Email",
      phone: "Phone",
      stateId: "state",
      middleInitials: "Name",
    };
    

    const validateField = (name, value, required = false,context="") => {
      const groupLabel = fieldGroupLabels[name] || name;      

     if (required && !value.trim()) {
    if (groupLabel === "state") {
      return "Please select a state.";
    }

    if (groupLabel === "company") {
      if (context === "agent") return "Invalid Agency Name";
      if (context === "business") return "Invalid Business Entity Name";
      if (context === "closingAgent") return "Invalid Company";
      return "Invalid Company Name"; // default
    }

    if (groupLabel === "individualLicenseNumber") {
      return "Invalid Individual License Number";
    }

    if (groupLabel === "agencyName") {
      return "Invalid Agency Name";
    }

    if (groupLabel === "agentIndvLicenseExpiryDate" || groupLabel === "licenseExpiryDate") {
      return "Invalid License Expiry Date";
    }

    return `Invalid ${groupLabel}`;
  }

      if (!required && !value.trim()) return "";
      if(validateAgentEmail?.length>0){        
        if(name==="email"){
          if(value === validateAgentEmail){
            return "Agent and Buyer email shouldn't be same"
          }
        }
      }
      // if(validateCobuyerEmail?.length>0){
      //   if(name==="email"){
      //     if(value === validateCobuyerEmail){
      //        return "Buyer and Co-buyer email shouldn't be same"
      //     }
      //   }
      // }
      const validationRule = validationPatterns[name];
      if (!validationRule) return "";

      // return validationRule.pattern.test(value) ? "" : validationRule.message;
      const isValid = validationRule.pattern.test(value);

  if (!isValid) {
    // Override message for 'company' based on context
    if (name === "company") {
      if (context === "agent") return "Invalid Agency Name";
      if (context === "business") return "Invalid Business Entity Name";
      if (context === "closingAgent") return "Invalid Company";
      return "Invalid Company Name"; // fallback
    }

    return validationRule.message;
  }

  return "";
    };

    const validationPatterns = {
      firstName: {
        pattern: /^[a-zA-Z0-9\-.'_]{1,50}$/,
        message: "Invalid Name",
      },
      lastName: {
        pattern: /^[a-zA-Z0-9\-.'_]{1,50}$/,
        message: "Invalid Name",
      },
      middleInitials: {
        pattern: /^[a-zA-Z0-9\-.'_]{1,50}$/,
        message: "Invalid Name",
      },
      email: {
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid Email",
      },
      phone: {
        pattern: /^[0-9]{10}$/,
        message: "Invalid Phone",
      },
      address1: {
        pattern: /^[a-zA-Z0-9#(),'\s]{1,}$/,
        message: "Invalid Address",
      },
      address2: {
        pattern: /^[a-zA-Z0-9#(),'\s]{1,}$/,
        message: "Invalid Address",
      },

      zip: {
        pattern: /^[0-9]{5}$/,
        message: "Invalid zip code",
      },
      state: {
        pattern: /^[A-Z]{2}$/,
        message: "Please select a valid state",
      },
      company: {
        pattern: /^[a-zA-Z0-9#(),'\s]{1,}$/,
        message: "Invalid business entity name",
      },
      agencyName:{
        pattern: /^[a-zA-Z0-9#@(),'\s]{1,}$/,
        message: "Invalid Agency Name",
      },
      corporateLicenseNumber:{
        pattern: /^[a-zA-Z0-9#(),'\s]{1,}$/,
        message: "Invalid Corp License Number",
      },
      individualLicenseNumber:{
        pattern: /^[a-zA-Z0-9#(),'\s]{1,}$/,
        message: "Invalid Individual License Number",
      },
      city :{
        pattern:/^[a-zA-Z0-9'\s]{1,}$/,
        message:"Invalid City"
      }
    };

    useEffect(() => {
      fetchStateValues();
      setErrors({})
    }, []);

    useEffect(() => {
      fetchCities();
      checkFormValidity();
    }, [cifFormetails?.stateId]);

    useEffect(() => {
      setErrors({})
      const initialFormData = fieldsConfig.reduce((acc, field) => {
        acc[field.name] = field.defaultValue || "";
        return acc;
      }, {});

      if (statePrefilled && !cifFormetails?.individualLicenseState) {
        initialFormData.individualLicenseState = statePrefilled;
      }
      const isFormEmpty = Object.values(initialFormData).every((value) => !value);
      checkFormValidity();
      setHaveErrors(isFormEmpty);
    }, [fieldsConfig, statePrefilled]);

    useEffect(() => {
      if (typeof registerValidationTrigger === "function") {
        registerValidationTrigger(validateForm);
      }
    }, [cifFormetails, errors]);
useEffect(() => {
  if (Object.keys(externalErrors).length > 0) {
    setErrors((prev) => ({
      ...prev,
      ...externalErrors,
    }));
  }
}, [externalErrors]);

    // This function validates everything and returns status + data
    const validateForm = () => {
      const newErrors = {};

      fieldsConfig.forEach((field) => {
        const value = cifFormetails[field.name];
        const isRequired = field.required;
        const error = validateField(field.name, value || "", isRequired,field.context);
        if (error) {
          newErrors[field.name] = error;
        }
      });
        const combinedErrors = { ...newErrors, ...externalErrors };

  setErrors(combinedErrors);


      // setErrors(newErrors); 
      // const hasErrors = Object.keys(newErrors).length > 0;
      const hasErrors = Object.keys(combinedErrors).length > 0;

      setHaveErrors(hasErrors);
        if (hasErrors) {
    const firstErrorField = Object.keys(combinedErrors)[0];
    const el = fieldRefs.current[firstErrorField];
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

      return {
        isValid: !hasErrors,
        data: cifFormetails,
        errors: combinedErrors,
      };
    };

    const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"
    ];
    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };


    return (
      <form className="row">
        {fieldsConfig.map((field) => (
          <>
          {            
            (field.label === "Name of the Business Entity")?
            <div className="row">
             <div key={field.name} className="field-group col-12 col-sm-6">
            <label className="fs-12" htmlFor={field.name}>
              {field.label}{" "}
              <span className="mandatory">{field.required && "*"}</span>
            </label>
              <div>
                <input
                  type={field.type}
                  name={field.name}
                  value={cifFormetails[field.name] || ""}
                  onChange={(e) => handleInputChange(field.name, e,field?.context)}
                  onBlur={(e) => handleBlur(field.name, e,field?.context)}
                  placeholder={field.placeholder}
                  required={field.required}
                  aria-label={field.name}
                  className={`form-control fs-12 ${errors[field.name] ? "border-error":""}`}
                  disabled={field.name === "email" && preFilledEmail}
                  maxLength={field?.maxLength?field?.maxLength:""}
                  onKeyDown={(field.name === "zip" || field.name === "phone") ? handleKeyDown : undefined}
                  min={
                    field?.type === "date"
                      ? new Date().toISOString().split("T")[0]
                      : undefined
                  }
                  ref={(el) => (fieldRefs.current[field.name] = el)}
                />
               
                {errors[field.name] && (
                  <p className="error-message-offer">{errors[field.name]}</p>
                )}
              </div>
            
          </div>
          <p className="indv-line">Individual representing the business entity </p>
            </div>:
             <div key={field.name} className={col==="col-12" ? "col-12 field-group" :"field-group col-12 col-sm-6"}>
            <label className="fs-12" htmlFor={field.name}>
              {field.label}{" "}
              <span className="mandatory">{field.required && "*"}</span>
            </label>
            {field.type === "select" ? (
              <div >
                <select
                  name={field.name}
                  value={cifFormetails?.[field.name] || ""}
                  onChange={(e) => handleInputChange(field.name, e,field?.context)}
                  onBlur={(e) => handleBlur(field.name, e,field?.context)}
                  required={field.required}
                  aria-label={field.name}
                  className={`form-select form-select fs-12  ${errors[field.name] ? "border-error":""}`}
                  disabled={
                    field.name === "individualLicenseState" && statePrefilled
                  }
                  ref={(el) => (fieldRefs.current[field.name] = el)}
                >
                  <option value="">Select {field.label}</option>
                  {state?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                {errors[field.name] && (
                  <p className="error-message-offer">{errors[field.name]}</p>
                )}
              </div>
            ) : (
              <div>
                <input
                  type={field.type}
                  name={field.name}
                  value={cifFormetails?.[field.name] || ""}
                  onChange={(e) => handleInputChange(field.name, e,field?.context)}
                  onBlur={(e) => handleBlur(field.name, e,field.context)}
                  placeholder={field.placeholder}
                  required={field.required}
                  aria-label={field.name}
                  className={`form-control fs-12 ${errors[field.name] ? "border-error":""}`}
                  disabled={field.name === "email" && preFilledEmail}
                  maxLength={field?.maxLength?field?.maxLength:""}
                  onKeyDown={(field.name === "zip" || field.name === "phone") ? handleKeyDown : undefined}
                  min={
                    field?.type === "date"
                      ? new Date().toISOString().split("T")[0]
                      : undefined
                  }
                  ref={(el) => (fieldRefs.current[field.name] = el)}
                />
                {field.name === "city" &&
                  showSuggestions &&
                  citySuggestions.length > 0 && (
                    <div className="suggestions-container-offer suggestions-container-bid ">
                      {citySuggestions.map((suggestion, index) => (
                        <div
                          key={index}
                          className="suggestion-item"
                          onClick={() => handleSuggestionClick(suggestion)}
                        >
                          {suggestion}
                        </div>
                      ))}
                    </div>
                  )}
                {/* {field.name === "zip" && zipTouched && invalidCombination && (
                  <p className="error-message-offer">
                    Invalid combination of State and ZIP code
                  </p>
                )} */}
                {errors[field.name] && (
                  <p className="error-message-offer">{errors[field.name]}</p>
                )}
              </div>
            )}
          </div>
          }
         
          </>
        ))}
      </form>
    );
  };

  export default DynamicForm;
